/**
 * @packageDocumentation
 * @module      P_Drive_Frame.ts
 * @description Contains Emc related data for Drive Frame
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import { toFixedDecimal } from "../utils";
export default class P_Drive_Frame {
    constructor() {
        this.X36V = '0';
        this.X5V = '0';
        this.X3V3 = '0';
        this.Temperature = '0';
    }
    static fromJSON(json) {
        if (json) {
            let p_Drive_Frame = new P_Drive_Frame();
            if (json.X36V) {
                p_Drive_Frame.X36V = toFixedDecimal(json.X36V);
            }
            if (json.X5V) {
                p_Drive_Frame.X5V = toFixedDecimal(json.X5V);
            }
            if (json.X3V3) {
                p_Drive_Frame.X3V3 = toFixedDecimal(json.X3V3);
            }
            if (json.Temperature) {
                p_Drive_Frame.Temperature = toFixedDecimal(json.Temperature);
            }
            return p_Drive_Frame;
        }
        return null;
    }
}
//# sourceMappingURL=P_Drive_Frame.js.map